module.exports = __webpack_public_path__ + "4b3219a335c13585312c06e3d82a0ce3.jpg";